(function () {
    'use strict';

    function initGalleryDots() {
        document.querySelectorAll('.product-hero__gallery[data-embla]').forEach(function (node) {
            const dotsWrap = node.querySelector('.product-hero__dots');
            if (!dotsWrap) return;

            function setActive() {
                const embla = node._embla;
                if (!embla) return;
                const i = embla.selectedScrollSnap();
                dotsWrap.querySelectorAll('.product-hero__dot').forEach((el, idx) => {
                    el.classList.toggle('is-active', idx === i);
                });
                const active = dotsWrap.querySelector('.product-hero__dot.is-active');
                if (active) {
                    const left = active.offsetLeft - (dotsWrap.clientWidth - active.offsetWidth) / 2;
                    dotsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
                }
            }

            function buildDots() {
                const embla = node._embla;
                dotsWrap.innerHTML = '';
                const count = embla ? embla.scrollSnapList().length : node.querySelectorAll('.embla__slide').length;
                for (let i = 0; i < count; i++) {
                    const b = document.createElement('button');
                    b.type = 'button';
                    b.className = 'product-hero__dot';
                    b.addEventListener('click', () => embla && embla.scrollTo(i));
                    dotsWrap.appendChild(b);
                }
                setActive();
            }

            function waitForEmbla() {
                if (node._embla) {
                    node._embla.on('select', setActive);
                    node._embla.on('reInit', buildDots);
                    buildDots();
                } else {
                    if (window.lpEmbla && window.lpEmbla.initEmblaFor) window.lpEmbla.initEmblaFor(node);
                    setTimeout(waitForEmbla, 50);
                }
            }
            waitForEmbla();
        });
    }

    function initGalleryFade() {
        const gallerySection = document.querySelector('.embla__container');
        const galleryControls = document.querySelector('.product-hero__controls');

        if (!gallerySection || !galleryControls) return;

        const mqMobile = window.matchMedia('(max-width: 1023px)');
        let ticking = false;

        const galleryBottomDoc = () => {
            if (!gallerySection) return 0;
            return gallerySection.offsetTop + gallerySection.offsetHeight;
        };

        const getFadeRange = () => (mqMobile.matches ? 280 : 520);

        const updateFade = () => {
            if (!gallerySection || !galleryControls) {
                ticking = false;
                return;
            }

            const range = getFadeRange();
            const y = window.scrollY || window.pageYOffset;
            const end = galleryBottomDoc();
            const start = end - range;

            let opacity;
            if (y <= start) opacity = 1;
            else if (y >= end) opacity = 0;
            else opacity = 1 - ((y - start) / (end - start));

            gallerySection.style.opacity = String(opacity);
            galleryControls.style.opacity = String(opacity);
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(updateFade);
                ticking = true;
            }
        };

        if (mqMobile.addEventListener) {
            mqMobile.addEventListener('change', updateFade);
        } else {
            mqMobile.addListener(updateFade);
        }

        updateFade();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', updateFade);
        window.addEventListener('orientationchange', updateFade);
    }

    function initProductNavMerge() {
        const navs = Array.from(document.querySelectorAll('.product-nav'));
        const mainHeader = document.querySelector('.header');
        if (!navs.length) return;

        const state = new Map();

        const getDocTop = (el) =>
            el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);

        const isVisible = (el) =>
            !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

        const recalc = () => {
            navs.forEach((nav) => {
                if (!isVisible(nav)) {
                    nav.classList.remove('is-merged');
                    return;
                }
                nav.classList.remove('is-merged');
                state.set(nav, { initialOffset: getDocTop(nav) });
            });
            update();
        };

        const update = () => {
            const mainHeaderHeight = mainHeader ? mainHeader.offsetHeight : 75;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            navs.forEach((nav) => {
                if (!isVisible(nav)) {
                    nav.classList.remove('is-merged');
                    return;
                }
                const data = state.get(nav);
                const initialOffset = data ? data.initialOffset : getDocTop(nav);

                if (scrollTop + mainHeaderHeight >= initialOffset) {
                    nav.classList.add('is-merged');
                } else {
                    nav.classList.remove('is-merged');
                }
            });
        };

        requestAnimationFrame(recalc);

        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', recalc);
        window.addEventListener('orientationchange', recalc);
        window.addEventListener('load', recalc);
    }

    function initMobileCTA() {
        const desktopCTA = document.querySelector('.product-info__cta');
        const mobileCTA = document.querySelector('.product-cta-mobile');
        const header = document.querySelector('.header');
        const headerH = header ? header.offsetHeight : 0;

        if (!desktopCTA || !mobileCTA) return;

        function checkCTAVisibility() {
            const rect = desktopCTA.getBoundingClientRect();
            const hiddenUp = rect.top <= headerH;

            const docHeight = document.documentElement.scrollHeight;
            const scrollY = window.scrollY || window.pageYOffset;
            const winHeight = window.innerHeight;

            const atBottom = scrollY + winHeight >= docHeight - 20;

            const shouldShow = hiddenUp && !atBottom;
            mobileCTA.classList.toggle('is-visible', shouldShow);
        }

        window.addEventListener('scroll', checkCTAVisibility, { passive: true });
        window.addEventListener('resize', checkCTAVisibility);
        checkCTAVisibility();
    }

    function initProductSectionsTabs() {
        const navs = Array.from(document.querySelectorAll('.product-nav'));
        const sections = Array.from(document.querySelectorAll('.product-section'));
        if (!navs.length || !sections.length) return;

        const linksById = new Map();
        const hasSection = (id) => sections.some(s => s.id === id);

        const mobileList = document.querySelector('.product-nav-container.product-nav--mobile .product-nav__list');

        navs.forEach(nav => {
            const links = Array.from(nav.querySelectorAll('a[href^="#"]'))
                .filter(a => {
                    const id = a.getAttribute('href').slice(1);
                    return hasSection(id);
                });

            links.forEach(a => {
                const id = a.getAttribute('href').slice(1);
                if (!linksById.has(id)) linksById.set(id, []);
                linksById.get(id).push(a);

                a.addEventListener('click', (e) => {
                    e.preventDefault();
                    setActive(id);

                    const clickedInMobile = a.closest('.product-nav-container.product-nav--mobile');

                    if (clickedInMobile && mobileList) {
                        const li = a.closest('li');
                        if (li) {
                            const listRect = mobileList.getBoundingClientRect();
                            const liRect = li.getBoundingClientRect();

                            const delta = liRect.left - listRect.left;

                            const extraPadding = 24;

                            const targetScroll = mobileList.scrollLeft + delta - extraPadding;

                            mobileList.scrollTo({
                                left: targetScroll,
                                behavior: 'smooth',
                            });
                        }
                    }

                    if (clickedInMobile) {
                        const section = document.getElementById(id);
                        if (section) {
                            const header = document.querySelector('.header');
                            const headerHeight = header ? header.offsetHeight : 0;
                            const extraOffset = 170;

                            const top =
                                section.getBoundingClientRect().top +
                                window.pageYOffset -
                                headerHeight -
                                extraOffset;

                            window.scrollTo({
                                top,
                                behavior: 'smooth',
                            });
                        }
                    }

                    if (history.replaceState) {
                        history.replaceState(null, '', '#' + id);
                    } else {
                        location.hash = id;
                    }
                });
            });
        });

        function setActive(targetId) {
            sections.forEach(s => s.classList.toggle('is-active', s.id === targetId));
            navs.forEach(nav => nav.querySelectorAll('a').forEach(a => a.classList.remove('active')));
            (linksById.get(targetId) || []).forEach(a => a.classList.add('active'));
        }

        const initialId = (location.hash && hasSection(location.hash.slice(1)))
            ? location.hash.slice(1)
            : (linksById.keys().next().value || null);

        if (initialId) {
            setActive(initialId);
        }
    }

    function initSidebarFadeOnStop() {
        const sidebar = document.querySelector('.product-hero__sidebar');
        const scope = document.querySelector('.product-sticky-scope');
        const desktopCTA = document.querySelector('.product-cta-desktop');

        if (!sidebar || !scope) return;

        const topOffset = parseInt(getComputedStyle(sidebar).top, 10) || 0;
        let ticking = false;

        const update = () => {
            const sb = sidebar.getBoundingClientRect();
            const sc = scope.getBoundingClientRect();

            const startedSticky = sb.top <= topOffset + 1;
            const reachedBottom = sb.bottom >= sc.bottom - 1;

            const isStopped = startedSticky && reachedBottom;

            sidebar.classList.toggle('is-stopped', isStopped);

            if (desktopCTA) {
                desktopCTA.classList.toggle('is-visible', isStopped);
            }

            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(update);
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        window.addEventListener('orientationchange', onScroll);
        update();
    }

    function init() {
        if (!document.querySelector('.product-hero')) return;

        initGalleryDots();
        initGalleryFade();
        initProductNavMerge();
        initMobileCTA();
        initProductSectionsTabs();
        initSidebarFadeOnStop();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
